import { ReactNode, useMemo } from "react";
import { ThemedButton } from "./Button";
interface TabsProps {
  tabList: string[];
  children: ReactNode;
  handleTab: (tab: string) => void;
  tab: string;
  newReplyFlags?: boolean[]; // 새로운 댓글 표시를 위한 플래그 배열
  tabBg?: string;
}
export const Tabs = ({
  tabList,
  children,
  handleTab,
  tab,
  newReplyFlags,
  tabBg = "bg-[#F5F5F5]",
}: TabsProps) => {
  const index = useMemo(
    () => tabList?.findIndex((name) => name === tab) ?? 0,
    [tab, tabList]
  );
  const content = useMemo(() => {
    if (children instanceof Array) {
      return children[index];
    }
    return children;
  }, [children, index]);

  return (
    <>
      <div className={`${tabBg} px-2 pt-2`}>
        <div className="flex bg-[#E9E9E9] rounded-full [&>*]:flex-1">
          {tabList?.map((name, idx) => (
            <div key={name} className="relative flex-1">
              <ThemedButton
                onClick={() => handleTab(name)}
                className="relative w-full rounded-full"
                color={tab === name ? "primary" : "tertiary"}
                >
                {name}
              </ThemedButton>
              {newReplyFlags && newReplyFlags[idx] && (
                <div
                className={
                  "flex absolute top-2 z-20 justify-center items-center w-1.5 h-1.5 text-sm font-bold rounded-full" +
                  " " +
                  (tab === name ? "bg-white" : "bg-[#ff9934]") +
                  " " +
                  (tabList.length == 2 ? "right-12" : "right-4")
                }
                ></div>
              )}
            </div>
          ))}
        </div>
      </div>
      {content}
    </>
  );
};
